// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"650f9ca0","4312":"3bd26f60","8162":"650f9ca0"}[chunkId] + ".chunk.css";
};